// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { application } from "./application"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import StimulusReflex from "stimulus_reflex";
import consumer from "../channels/consumer";
import controller from '../controllers/application_controller'
import NestedForm from "stimulus-rails-nested-form"
import GeolocationController from "./geolocation_controller"
application.register("geolocation", GeolocationController)
const context = require.context(".", true, /_controller\.js$/)
const definitions = definitionsFromContext(context)
console.log("Controller definitions found:", definitions)
application.load(definitions)
console.log("Stimulus application:", application)
console.log("Registered controllers:", application.router.modulesByIdentifier)
StimulusReflex.initialize(application, { consumer });
console.log("StimulusReflex initializeadadfd");
application.register("nested-form", NestedForm)
console.log('is this workingadf')

console.log('invite accordion controller registered')
if (process.env.RAILS_ENV === 'development') {
  import('radiolabel').then(Radiolabel =>
    application.register('radiolabel', Radiolabel.default)
  )
}
